import { createStructuredSelector } from 'reselect';
import {
  TDLV_LIST, TDLV_LIST_SUCCESS, TDLV_LIST_ERROR, TDLV_PAGE_SET,
  TDLV_ADD, TDLV_ADD_SUCCESS, TDLV_ADD_ERROR,
  TDLV_SEARCH_CHANGE,
  TDLV_FILTER_TASK_STATUS, TDLV_FILTER_TASK_STATUS_SUCCESS,
  TDLV_FILTER_SUPPLIERS, TDLV_FILTER_SUPPLIERS_SUCCESS,
  TDLV_FILTER_DESTINATIONS, TDLV_FILTER_DESTINATIONS_SUCCESS
} from '../../actions';

export const NAME = 'task_delivery';

export const TaskDeliveryList = (page, num_page, orderBy, filters) => ({ type: TDLV_LIST, payload: { page, num_page, orderBy, filters } });
export const TaskDeliveryListSuccess = (data) => ({ type: TDLV_LIST_SUCCESS, payload: data });
export const TaskDeliveryListError = (error) => ({ type: TDLV_LIST_ERROR, payload: error });
export const TaskDeliveryPageSet = (data) => ({ type: TDLV_PAGE_SET, payload: data });
export const TaskDeliveryAdd = (data) => ({ type: TDLV_ADD, payload: data });
export const TaskDeliveryAddSuccess = (data) => ({ type: TDLV_ADD_SUCCESS, payload: data });
export const TaskDeliveryAddError = (error) => ({ type: TDLV_ADD_ERROR, payload: error });
export const TaskDeliverySearchChange = (data) => ({ type: TDLV_SEARCH_CHANGE, payload: data });
export const TaskDeliveryFilterTaskStatus = () => ({ type: TDLV_FILTER_TASK_STATUS });
export const TaskDeliveryFilterTaskStatusSuccess = (data) => ({ type: TDLV_FILTER_TASK_STATUS_SUCCESS, payload: data });
export const TaskDeliveryFilterSuppliers = () => ({ type: TDLV_FILTER_SUPPLIERS });
export const TaskDeliveryFilterSuppliersSuccess = (data) => ({ type: TDLV_FILTER_SUPPLIERS_SUCCESS, payload: data });
export const TaskDeliveryFilterDestinations = () => ({ type: TDLV_FILTER_DESTINATIONS });
export const TaskDeliveryFilterDestinationsSuccess = (data) => ({ type: TDLV_FILTER_DESTINATIONS_SUCCESS, payload: data });

const task_delivery = (state) => state[NAME];
export const TaskDeliverySelector = createStructuredSelector({ task_delivery });
